import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

// Actions
import { createCampaign } from "../../../../actions/campaign/CampaignActions";
import { getRegionNames } from "../../../../actions/regions/RegionActions";
import { getTargetGroups } from "../../../../actions/org/OrgTargetGroupActions";

// Constants
import { defaultPagination } from "../../../../constants/UrlConstants";

// Components
import Spinner from "../../../../components/spinner/Spinner";
import MultiCitySelectionForm from "../../../../mavin/components/multi-city-selection-form/MultiCitySelectionForm";
import {
  PlanSetupAddCities,
  PlanSetupFooter,
  PlanSetupHeader,
  PlanSetupStartDateAndDuration,
  PlanSetupTargetGroupAndBudget,
  PlanSetupTitle,
} from "../../../../components/campaign-plan-setup-utils/CampaignPlanSetupUtils";

// CSS
import "../../../../pages/campaign-planning/CampaignPlanning.scss";

/**
 * Page
 */
export default function CampaignPlanSetupPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  // State
  const [title, setTitle] = useState("");
  const [infoByCity, setInfoByCity] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tgId, setTgId] = useState("");
  const [budget, setBudget] = useState(0);

  // Selector State
  const regionsName = useSelector((state) => state.region.regionsName) || [];
  const regionsNameLoading = useSelector((state) => state.region.namesLoading);

  // target group list
  const tgList = useSelector((state) => state.orgTargetGroup.tgTitles) || [];

  // for "MULTIPLE-City-Selection-form"
  const openMultiCitySelectionForm = useSelector(
    (state) => state.multiCitySelectionModal.openModal
  );
  // Pagination
  const pageNo = defaultPagination.pageNo,
    pageSize = defaultPagination.pageSize;

  // Dispatch
  useEffect(() => {
    dispatch(getRegionNames());
    dispatch(getTargetGroups(false, "", pageNo, pageSize));
  }, [dispatch]);

  // Create Campaign Submit Button
  function handleSubmit() {
    dispatch(
      createCampaign(
        { infoByCity, title, startDate, endDate, tgId, budget },
        history
      )
    );
  }

  // campaign plan setup button
  const isPlanCampaignBtnDisabled =
    !title || (startDate && !endDate) || infoByCity.length == 0 || !tgId;

  // Loading
  if (regionsNameLoading) {
    return <Spinner className="spinner-center mt-2" />;
  }

  return (
    <div className="content-wrapper">
      {/* Page- header */}
      <PlanSetupHeader />

      <div className="page-content">
        <div className="row">
          <div className="col-6">
            {/* Campaign-title */}
            <PlanSetupTitle title={title} setTitle={setTitle} />

            {/* StartDate and Duration */}
            <PlanSetupStartDateAndDuration
              startDate={startDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />

            {/* TG And Budget */}
            <PlanSetupTargetGroupAndBudget
              tgList={tgList}
              setTg={setTgId}
              isShowBudget={true}
              budget={budget}
              setBudget={setBudget}
            />

            {/* Selected Cities Container */}
            <PlanSetupAddCities
              infoByCity={infoByCity}
              setInfoByCity={setInfoByCity}
            />

            {/* Page-Footer Section */}
            <PlanSetupFooter
              handleSubmit={handleSubmit}
              disable={isPlanCampaignBtnDisabled}
            />
          </div>
        </div>
      </div>

      {/* MODALS */}
      {openMultiCitySelectionForm && (
        <MultiCitySelectionForm
          regionsName={regionsName}
          onSubmit={setInfoByCity}
          citiesList={infoByCity}
        />
      )}
    </div>
  );
}
